import { mapState, mapGetters, mapActions } from 'vuex'
import Swal from "sweetalert2";

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    provinces: (state) => state.provinces,
    cities: (state) => state.cities,
    barangays: (state) => state.barangays,
    regions: (state) => state.regions
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    layoutScrollable: (state) => state.layoutScrollable,
    layoutMode: (state) => state.layoutMode,
    leftSidebarType: (state) => state.leftSidebarType,
    sidebarColor: (state) => state.sidebarColor,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    breadCrumbs: (state) => state.breadCrumbs,
    title: (state) => state.title,
    showBackButton: (state) => state.showBackButton,
    previousRoute: (state) => state.previousRoute
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword', 'confirm', 'fetchProvinces','fetchCities', 'fetchBarangays', 'fetchRegions','resendCode', 'forgotPassword','isUserAvailable', 'changeUserPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutMode', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeSidebarColor', 'changeLayoutPosition','changeBreadCrumb','changeTitle','changeBackButton','changePrevRoute'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}

export const todoMethods = mapActions('todo', ['fetchTodos'])

export const organizationMethods = mapActions('organization', ['createOrganization','uploadBusinessLogo'])

export const organizationComputed = {
  ...mapState('organization', {
    business: (state) => state.business
  })
}

export const addressMethods = mapActions('address', ['fetchCountries', 'fetchProvinces', 'fetchCities', 'fetchBarangays', 'fetchRegions'])

export const addressComputed = {
  ...mapState('address', {
    provinces: (state) => state.provinces,
    cities: (state) => state.cities,
    barangays: (state) => state.barangays,
    regions: (state) => state.regions,
    countries: (state) => state.countries
  })
}


export const profileMethods = mapActions('profile', ['fetchUserProfile', 'updateUserProfile', 'uploadBusinessLogo', 'uploadProfilePicture', 'fetchUserProfilePicture'])

export const profileComputed = {
    ...mapState('profile', {
        userData: (state) => state.userData
    })
}

export const listingMethods = mapActions('listing', ['fetchListings','fetchLandmarks','fetchAllLandmarks','fetchPlacements','fetchTarpaulinSizes','fetchBannerSizes','fetchWindowBoxSizes','fetchHangerSizes','fetchPublicListings','fetchPublicLandmarks','fetchPublicStoreDetails','fetchStoreHistory','updateCarts','fetchFavoriteListings','addToFavoriteListings', 'removeToFavoriteListings'])

export const listingComputed = {
  ...mapState('listing', {
    listings: (state) => state.listings,
    landmarks: (state) => state.landmarks,
    tarpaulins: (state) => state.tarpaulins,
    banners: (state) => state.banners,
    windowBoxes: (state) => state.windowBoxes,
    hangers: (state) => state.hangers,
    collateralPlacements: (state) => state.collateralPlacements,
    rentHistoryList: (state) => state.rentHistoryList,
    listinTotalRows: (state) => state.listinTotalRows,
    carts: (state) => state.carts,
    favoriteListing: (state) => state.favoriteListing,
    favoritelistinTotalRows: (state) => state.favoritelistinTotalRows,
    businessDetails: (state) => state.businessDetails,
    businessHistory: (state) => state.businessHistory
  })
}
export const walletMethods = mapActions('wallet', [
  'fetchPaymentMethods',
  'fetchWalletSkus',
  'paymodeOne',
  'paymodeTwo',
  'modeOneStatus',
  'modeTwoStatus',
  'testTrigger',
  'fetchWalletBalance',
  'fetchHoldBalance',
  'uploadProofOfPayment',
  'createBankTransfer'
])

export const walletComputed = {
  ...mapState('wallet', {
    paymentMethodList: (state) => state.paymentMethodList,
    walletSkus: (state) => state.walletSkus,
    walletBalance: (state) => state.walletBalance,
    holdBalance: (state) => state.holdBalance
  })
}

export const rolesMethods = mapActions('role', [
  'getRolesList',
  'getRole',
  'createRoleItem',
  'updateRoleItem',
  'deleteRoleItem',
  'getModules'
])

export const rolesComputed = {
  ...mapState('role', {
    roleItem: (state) => state.roleItem,
    rolesList: (state) => state.rolesList,
    rolesTotal: (state) => state.rolesTotal,
    modules: (state) => state.modules
  })
}

export const usersMethods = mapActions('user', [
  'getUsersList',
  'getUser',
  'submitUser',
  'deleteUserItem',
  'getUserAccess',
  'getUserBySub'
])

export const usersComputed = {
  ...mapState('user', {
    userItem: (state) => state.userItem,
    usersList: (state) => state.usersList,
    usersTotal: (state) => state.usersTotal,
    currentUser: (state) => state.currentUser,
  })
}

export const campaignMethods = mapActions('campaign', [
  'getCampaignList',
  'getCampaign',
  'getCollateralList'
])

export const campaignComputed = {
  ...mapState('campaign', {
    campaign: (state) => state.campaign,
    campaignList: (state) => state.campaignList,
    campaignsTotal: (state) => state.campaignsTotal,
    collateralsList: (state) => state.collateralsList,
    collateralsTotal: (state) => state.collateralsTotal,
  })
}

export function showFeatureUnavailable() {
  Swal.fire({
    position: 'bottom-end',
    //style="background: #0062FF;color: #fff;"
    html: `
    <div class="row">
      <div class="col-2 d-flex align-items-center justify-content-center">
        <i class="bx bx-info-circle text-info" style="font-size:40px;"></i>
      </div>
      <div class="col-10" style="text-align:left">
        <p class="m-0 mt-1"><b>Feature Unavailable</b></p>
        <p class="ts-13 m-0">The function is temporary disabled</p>
      </div>
    </div>
    `,
    customClass: {
      container: 'm-0 p-0',
      popup: 'p-0 mb-4 me-4',
      // header: 'your-header-class',
      // title: 'your-title-class',
      // closeButton: 'your-close-button-class',
      // icon: 'your-icon-class',
      // image: 'your-image-class',
      content: 'm-0 p-0',
      // input: 'your-input-class',
      // actions: 'your-actions-class',
      // confirmButton: 'your-confirm-button-class',
      // cancelButton: 'your-cancel-button-class',
      // footer: 'your-footer-class'
    },
    showConfirmButton: false,
    timer: 1500
  })
}

export const auditSpaceMethods = mapActions('auditspace', ['fetchAuditSpaceList','fetchStoreInfo','fetchStoreSpaceInfo','fetchStoreShipOut','fetchAuditSpaceLogs','auditSpaceActionForm','auditSpaceCronReleasePayment'])

export const auditSpaceComputed = {
  ...mapState('auditspace', {
    auditSpaceList: (state) => state.auditSpaceList,
    auditSpaceTotalRows: (state) => state.auditSpaceTotalRows,
    auditStoreInfo: (state) => state.auditStoreInfo,
    auditStoreInfoSpaceRented: (state) => state.auditStoreInfoSpaceRented,
    auditStoreStatus: (state) => state.auditStoreStatus,
    auditShipStatus: (state) => state.auditShipStatus,
    auditTimeline: (state) => state.auditTimeline,
  })
}

export const checkoutMethods = mapActions('checkout', ['fetchCheckoutItems','addToCart','toggleStoreSpaces','confirmOrder'])

export const checkoutComputed = {
  ...mapState('checkout', {
    checkoutItems: (state) => state.checkoutItems,
    checkoutTotalRows: (state) => state.checkoutTotalRows
  })
}